import { css } from 'goober';
import React, { useCallback } from 'react';
import { Actions } from '../../enums/Actions';
import { useAppContext } from '../../reducer';
import colors from '../../styles/colors';
import { transparentize } from '../../styles/mixins';
import { MuteIcon, UnMuteIcon } from '../MuteAndUnmuteIcon';
const AudioContainer = css `
  width: 23px;
  height: 23px;
  flex-grow: 0;
  margin: 0;
  padding: 5px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(72px);
  background-color: ${transparentize(0.85, colors.black)};
`;
const Audio = () => {
    const { state: { isMuted }, dispatch, } = useAppContext();
    const toggleAudio = useCallback(() => {
        dispatch({ type: Actions.TOGGLE_AUDIO });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const AudioIcon = isMuted ? MuteIcon : UnMuteIcon;
    return (React.createElement("div", { className: AudioContainer, onClick: toggleAudio, role: "button" },
        React.createElement(AudioIcon, null)));
};
export default Audio;
//# sourceMappingURL=index.js.map